/**
 * One-click image downloader - Grabit — bulk image downloader
 *
 * Declares a single web-accessible-resource: `icon_128.png`, matched to all http(s)
 * origins with no `use_dynamic_url`. That one file is fetchable from any page at a
 * fixed URL, so its presence is conclusive — it is served only when Grabit is installed.
 *
 * Being an image, it loads through `probeImage` with no CORS grant, so it survives a
 * restrictive page CSP. It is the only exposed resource, so there is no corroborator.
 *
 * Manifest verified against version 3.8.3.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'djcobamaplcmhmaocomnkfdbcoiggepo';

export const grabit: ExtensionDefinition = {
  id: ID,
  name: 'One-click image downloader - Grabit',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 30_000,
  notes:
    'Exposes exactly one WAR, icon_128.png, to all http(s) origins with no dynamic ' +
    'URL. A single <img> load is conclusive and needs no CORS grant.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load icon_128.png via <img> — the sole web-accessible resource, exposed to ' +
        'every http(s) origin; needs no CORS grant, so it works under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'icon_128.png'),
    },
  ],
};
